module.exports = __webpack_public_path__ + "static/media/hssp.0fb0d2b.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/hssp.mp4
// module id = 2UYg
// module chunks = 1